import styled from "styled-components";
import Color from "./../../assets/color";

const VoucherCompStyled = styled.div`
  height: 100%;

  .outer-div {
    border: 1.5px dashed ${Color.aluminium};
    overflow: hidden;
    padding: 5px;
    position: relative;
    // height: 265px;
    height: 100%;
    .checkbox {
      position: absolute;
      top: 6px;
    }
  }
  .hover {
    :hover {
      cursor: pointer;
    }
  }
  .background {
    transition: all 0.5s ease;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 100%;
    height: 150px;
    &.hover:hover {
      transform: scale(1.05);
    }
  }
  .circle {
    position: absolute;
    font-family: "Lato Black", sans-serif;
    text-transform: uppercase;
    border-radius: 50px;
    font-size: 10px;
    top: 8px;
    color: ${Color.white};
  }
  .chop {
    right: 8px;
    .image {
      width: 50px;
      height: 50px;
    }
  }
  .tag {
    left: 8px;
    padding: 3px;
  }
  .sold-out {
    background: ${Color.razz};
  }
  .redeemed {
    background: ${Color.pistachio};
  }
  .refunded {
    background: ${Color.emperor};
  }
  .expired {
    background: ${Color.shuttleGray};
  }
  .discount {
    position: absolute;
    right: 8px;
    border: solid 3px ${Color.white};
    border-radius: 50px;
    background-color: ${Color.primary};
    color: ${Color.white};
    font-weight: bolder;
    padding: 2px;
    // top: 54%;
    top: 141px;
  }

  .contain {
    position: relative;
    top: 6px;
    padding-bottom: 5px;

    .info {
      display: table;
      width: 100%;
      padding: 5px 0;
      text-align: left;

      .alignment {
        display: table-cell;
        vertical-align: top;
      }
      .icon {
        width: 40px;
        padding-right: 5px;
        img {
          width: 100%;
        }
      }
      .title {
        font-family: "Lato Bold", sans-serif;
      }
      .time {
        color: ${Color.nobel};
        font-family: "Lato Bold", sans-serif;
      }
      .item-price {
        text-decoration: line-through;
        padding-right: 8px;
      }
      .package-price {
        font-family: "Lato Black", sans-serif;
        font-size: 17px;
        color: ${Color.emperor};
        padding-right: 3px;
        text-align: center;
      }
      .applicable {
        color: ${Color.nobel};
      }
    }
    p {
      font-family: "Lato", sans-serif;
    }
    p,
    h5 {
      margin-bottom: 2px;
      line-height: 1rem;
    }
  }
  .checkBox {
    overflow: unset;
    &.select {
      border: 2px solid ${Color.primary};
    }
    /* The container */
    label {
      display: block;

      cursor: pointer;
      font-size: 22px;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      position: absolute;
      top: 5px;
      right: 35px;
    }

    /* Hide the browser's default checkbox */
    label input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;
    }

    /* Create a custom checkbox */
    .checkmark {
      position: absolute;
      top: 0;
      left: 0;
      height: 30px;
      width: 30px;
      background-color: ${Color.aluminium};
    }

    /* On mouse-over, add a grey background color */
    label:hover input ~ .checkmark {
      background-color: #ccc;
    }

    /* When the checkbox is checked, add a blue background */
    label input:checked ~ .checkmark {
      background-color: ${Color.pistachio};
    }

    /* Create the checkmark/indicator (hidden when not checked) */
    .checkmark:after {
      content: "";
      position: absolute;
      display: none;
    }

    /* Show the checkmark when checked */
    label input:checked ~ .checkmark:after {
      display: block;
    }

    /* Style the checkmark/indicator */
    label .checkmark:after {
      left: 10px;
      top: 4px;
      width: 9px;
      height: 18px;
      border: solid white;
      border-width: 0 3px 3px 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
    }
  }
  .unavailable {
    :after {
      background-color: rgba(255, 255, 255, 0.8);
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      display: block;
      content: " ";
      z-index: 10;
    }
  }
`;

const VoucherCarouselCardStyled = styled.div`
  background-color: ${Color.white};
  padding: 0.8rem;
  position: relative;
  overflow: hidden;
  border-radius: 1rem;

  p {
    margin-bottom: 0;
  }
  .discount-percentage {
    position: absolute;
    width: 60px;
    height: 60px;
    left: -8px;
    top: -8px;
    background: ${Color.primary};
    padding: 14px;
    padding-right: 10px;
    padding-bottom: 10px;
    border-radius: 100%;
    border-top-left-radius: 0;
    color: ${Color.white};
    text-align: center;
    z-index: 5;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .voucher-card-container {
    @media (min-width: 1200px) {
      flex-direction: column;
    }

    .voucher-image-container {
      position: relative;
      width: 110px;
      height: calc(3 / 4 * 110px);

      @media (min-width: 1200px) {
        width: 100%;
        padding-bottom: 60%;
        margin-bottom: 1rem;
      }

      .voucher-image {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        border: 2px solid ${Color.primary};
        border-radius: 12px;

        @media (min-width: 1200px) {
          margin-bottom: 1rem;
        }
      }
    }

    .voucher-info {
      flex: 1;
      min-width: 0;

      .title {
        margin-bottom: 0.25rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .valid-till {
        color: ${Color.emperor};
      }

      .sales {
        color: ${Color.nobel};
        font-size: 12px;
        margin-top: 0.25rem;
        margin-bottom: 0.25rem;
      }

      .voucher-title {
        font-family: "Lato Black", sans-serif;
        font-size: 18px;
      }

      .price-container {
        flex: 1;
        padding-right: 1rem;

        .price {
          font-family: "Lato Black", sans-serif;
          font-size: 16px;
          color: ${Color.primary};
        }

        .actual-price {
          text-decoration: line-through;
        }
      }

      .voucher-icon {
        margin-bottom: -8px;
        margin-top: -8px;
      }
    }
  }
`;

export { VoucherCarouselCardStyled };
export default VoucherCompStyled;
